module.exports = __webpack_public_path__ + "9ed92a64259c1b8482654804fed867fb.svg";